// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsBindings$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as PathHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/PathHelpers.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as AnalyticsHelper$PorterinFeature from "./AnalyticsHelper.mjs";
import * as PageviewConstants$PorterinFeature from "../constants/PageviewConstants.mjs";

var prod_canonical_url_BD = "https://porter.com.bd";

var prod_canonical_url_UAE = "https://porter.ae";

var prod_canonical_url_IN = "https://porter.in";

function getCanonicalUrl(router) {
  var locale = router.locale;
  var url = locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD ? prod_canonical_url_BD : (
      locale === LocaleConstants$PorterinUtils.en_AE || locale !== LocaleConstants$PorterinUtils.en_IN ? prod_canonical_url_UAE : prod_canonical_url_IN
    );
  var match = PathHelpers$PorterinUtils.getRoutePathList(router.pathname);
  var server_path;
  if (match) {
    switch (match.hd) {
      case "bikes" :
          var match$1 = match.tl;
          server_path = match$1 && !match$1.tl ? PageviewConstants$PorterinFeature.ga_path_bike_parcel_keyword_prefix + AnalyticsHelper$PorterinFeature.getPillarPageName(router.asPath, 1) : PathHelpers$PorterinUtils.getUrlPathString(router.asPath);
          break;
      case "trucks" :
          var match$2 = match.tl;
          if (match$2) {
            var match$3 = match$2.tl;
            server_path = match$3 ? (
                match$3.tl ? PathHelpers$PorterinUtils.getUrlPathString(router.asPath) : PageviewConstants$PorterinFeature.ga_path_trucks_prefix + AnalyticsHelper$PorterinFeature.getPillarPageName(router.asPath, 1) + "/" + AnalyticsHelper$PorterinFeature.getPillarPageName(router.asPath, 2)
              ) : PageviewConstants$PorterinFeature.ga_path_trucks_prefix + AnalyticsHelper$PorterinFeature.getPillarPageName(router.asPath, 1);
          } else {
            server_path = PathHelpers$PorterinUtils.getUrlPathString(router.asPath);
          }
          break;
      default:
        server_path = PathHelpers$PorterinUtils.getUrlPathString(router.asPath);
    }
  } else {
    server_path = PathHelpers$PorterinUtils.getUrlPathString(router.asPath);
  }
  var browser_path = PathHelpers$PorterinUtils.getUrlPathString(router.asPath);
  if (JsBindings$PorterinUtils.isBrowser(undefined)) {
    return url + browser_path;
  } else {
    return url + server_path;
  }
}

export {
  prod_canonical_url_BD ,
  prod_canonical_url_UAE ,
  prod_canonical_url_IN ,
  getCanonicalUrl ,
}
/* JsBindings-PorterinUtils Not a pure module */
